import React from 'react';
import IMG1 from '../../assets/portfolio1.jpg';
import IMG2 from '../../assets/portfolio2.jpg';
import IMG3 from '../../assets/portfolio3.jpg';
import IMG4 from '../../assets/portfolio4.jpg';
import IMG5 from '../../assets/portfolio5.png';
import IMG6 from '../../assets/portfolio6.jpg';
import './Portfolio.css';

const Portfolio = ({ t }) => {
  return (
    <section id='portfolio'>
      <h5>{t("portfolio-title")}</h5>
      <h2>{t("portfolio-subtitle")}</h2>

      <div className="container portfolio__container">

        <article className="portfolio__item">
          <div className="portfolio__item-image">
              <img src={ IMG1 }  alt={t("portfolio-card1-image-alt")} />
            </div>
            <h3>{t("portfolio-card1-title")}</h3>
            <div className="portfolio__item-cta">
              <a className='btn' href="https://github.com/rafaelPermec/portifolio-de-exercicios-trybe">Github</a>
              {/* <a 
                className='btn btn-primary' 
                href="https://github.com/rafaelPermec"
                target='_blank' 
                rel="noreferrer"
              >
                  {t("root-portfolio-btn")}
              </a> */}
            </div>
        </article>

        <article className="portfolio__item">
          <div className="portfolio__item-image">
              <img src={ IMG2 }  alt={t("portfolio-card2-image-alt")} />
            </div>
            <h3>{t("portfolio-card2-title")}</h3>
            <div className="portfolio__item-cta">
              <a className='btn' href="https://github.com/rafaelPermec/live-broker-api">Github</a>
              {/* <a 
                className='btn btn-primary' 
                href="https://github.com/rafaelPermec"
                target='_blank' 
                rel="noreferrer"
              >
                  {t("root-portfolio-btn")}
              </a> */}
            </div>
        </article>

        <article className="portfolio__item">
          <div className="portfolio__item-image">
              <img src={ IMG3 }  alt={t("portfolio-card3-image-alt")} />
            </div>
            <h3>{t("portfolio-card3-title")}</h3>
            <div className="portfolio__item-cta">
              <a className='btn' href="https://github.com/rafaelPermec">Github</a>
              <a 
                className='btn btn-primary' 
                href="https://github.com/rafaelPermec"
                target='_blank' 
                rel="noreferrer"
              >
                  {t("root-portfolio-btn")}
              </a>
            </div>
        </article>

        <article className="portfolio__item">
          <div className="portfolio__item-image">
              <img src={ IMG4 }  alt={t("portfolio-card4-image-alt")} />
            </div>
            <h3>{t("portfolio-card4-title")}</h3>
            <div className="portfolio__item-cta">
              <a className='btn' href="https://github.com/rafaelPermec/trivia-react-redux">Github</a>
              <a 
                className='btn btn-primary' 
                href="https://rafaelpermec.github.io/trivia-react-redux/"
                target='_blank' 
                rel="noreferrer"
              >
                  {t("root-portfolio-btn")}
              </a>
            </div>
        </article>

        <article className="portfolio__item">
          <div className="portfolio__item-image">
              <img src={ IMG5 }  alt={t("portfolio-card5-image-alt")} />
            </div>
            <h3>{t("portfolio-card5-title")}</h3>
            <div className="portfolio__item-cta">
              <a className='btn' href="https://github.com/rafaelPermec/trybestore-shopping-cart">Github</a>
              <a 
                className='btn btn-primary' 
                href="https://rafaelpermec.github.io/trybestore-shopping-cart/"
                target='_blank' 
                rel="noreferrer"
              >
                  {t("root-portfolio-btn")}
              </a>
            </div>
        </article>

        <article className="portfolio__item">
          <div className="portfolio__item-image">
              <img src={ IMG6 }  alt={t("portfolio-card6-image-alt")} />
            </div>
            <h3>{t("portfolio-card6-title")}</h3>
            <div className="portfolio__item-cta">
              <a className='btn' href="https://github.com/rafaelPermec/pokemon-trainer-party">Github</a>
              {/* <a 
                className='btn btn-primary' 
                href="https://github.com/rafaelPermec"
                target='_blank' 
                rel="noreferrer"
              >
                  {t("root-portfolio-btn")}
              </a> */}
            </div>
        </article>

      </div>
    </section>
  )
}

export default Portfolio;
